// extracted by mini-css-extract-plugin
export var armyBuilderRoster = "blog-post-module--armyBuilderRoster--tAh2T";
export var article = "blog-post-module--article--dQKQ+";
export var articleNavigation = "blog-post-module--articleNavigation--204p8";
export var body = "blog-post-module--body--fmI8r";
export var container = "blog-post-module--container--I0jV6";
export var embeddedArmyList = "blog-post-module--embeddedArmyList--nSAkg";
export var embeddedArmyListOutput = "blog-post-module--embeddedArmyListOutput--tsWTt";
export var embeddedArmyListSummary = "blog-post-module--embeddedArmyListSummary--oe4-J";
export var embeddedArmyListTitle = "blog-post-module--embeddedArmyListTitle--K2LVs";
export var embeddedAsset = "blog-post-module--embeddedAsset--HYkJ+";
export var embeddedEntityBlock = "blog-post-module--embeddedEntityBlock--r9hVL";
export var embeddedEntityContent = "blog-post-module--embeddedEntityContent--vemmX";
export var embeddedEntityInline = "blog-post-module--embeddedEntityInline--KXj-O";
export var embeddedEntityLink = "blog-post-module--embeddedEntityLink--Gq+4P";
export var embeddedEntitySummary = "blog-post-module--embeddedEntitySummary--NQcZQ";
export var embeddedEntityTitle = "blog-post-module--embeddedEntityTitle--9V83f";
export var embeddedEntityType = "blog-post-module--embeddedEntityType--myzhW";
export var meta = "blog-post-module--meta--XwIyg";
export var xmlAttrName = "blog-post-module--xmlAttrName--QVZMd";
export var xmlAttrValue = "blog-post-module--xmlAttrValue--4X0Pt";
export var xmlBlock = "blog-post-module--xmlBlock--16i-K";
export var xmlPunctuation = "blog-post-module--xmlPunctuation--CLJXY";
export var xmlTag = "blog-post-module--xmlTag--2v3kz";